import styled, { device } from "@styled";

export const SectionWrap = styled.section`
    padding-block-start:50px;
`;